// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/effects_editor/effects/templates/components/effect-header/template.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_attrs0 = {
        "class": "effect-header"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("d2434a"),
    marko_node0 = marko_createElement("div", {
        "class": "delete"
      }, "1", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          "class": "delete"
        }, null, null, 1)
        .e("span", {
            "class": "fa fa-close"
          }, null, null, 0),
    marko_attrs1 = {
        "class": "name"
      },
    marko_node1 = marko_createElement("div", {
        "class": "bypass"
      }, "5", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("input", {
          type: "checkbox",
          id: "bypass",
          "class": "bypass",
          checked: "true"
        }, null, null, 0);

function render(input, out, __component, component, state) {
  var data = input;

  out.e("div", marko_attrs0, "0", component, 3)
    .n(marko_node0, component)
    .e("div", marko_attrs1, "4", component, 1)
      .t(data.name, component)
    .n(marko_node1, component);
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
